'use client';

import { Box, Container, Image, Text } from '@doist/marketist';
import { useTranslation } from 'app/i18n/client';
import { useLocale } from 'next-intl';
import css from './three-column-section.module.css';
const imageLocations = {
  dailyGoals: {
    imageSrc: '/static/karma/benefits/daily-goals.png',
    width: 127,
    height: 90
  },
  features: {
    imageSrc: '/static/karma/benefits/features.png',
    width: 135,
    height: 90
  },
  visualization: {
    imageSrc: '/static/karma/benefits/visualization.png',
    width: 138,
    height: 90
  }
};
function ThreeColumnSection() {
  const locale = useLocale();
  const {
    t
  } = useTranslation(locale, 'karma');
  return <Container className={css.container} data-sentry-element="Container" data-sentry-component="ThreeColumnSection" data-sentry-source-file="three-column-section.tsx">
            <FeatureBox title={t('features.goal')} description={t('features.goalDes')} {...imageLocations.dailyGoals} data-sentry-element="FeatureBox" data-sentry-source-file="three-column-section.tsx" />
            <FeatureBox title={t('features.points')} description={t('features.pointsDes')} {...imageLocations.features} data-sentry-element="FeatureBox" data-sentry-source-file="three-column-section.tsx" />
            <FeatureBox title={t('features.visualize')} description={t('features.visualizeDes')} {...imageLocations.visualization} data-sentry-element="FeatureBox" data-sentry-source-file="three-column-section.tsx" />
        </Container>;
}
function FeatureBox({
  title,
  description,
  imageSrc,
  width,
  height
}: {
  title: string;
  description: string;
  imageSrc: string;
  width: number;
  height: number;
}) {
  return <Box className={css.featureBox} data-sentry-element="Box" data-sentry-component="FeatureBox" data-sentry-source-file="three-column-section.tsx">
            <Image src={imageSrc} width={width} height={height} alt="" data-sentry-element="Image" data-sentry-source-file="three-column-section.tsx" />
            <Box className={css.text} data-sentry-element="Box" data-sentry-source-file="three-column-section.tsx">
                <Text size="minor-xl" weight="semibold" data-sentry-element="Text" data-sentry-source-file="three-column-section.tsx">
                    {title}
                </Text>
                <Text className={css.subtitle} size="body-sm" data-sentry-element="Text" data-sentry-source-file="three-column-section.tsx">
                    {description}
                </Text>
            </Box>
        </Box>;
}
export { ThreeColumnSection };